import { useState, useEffect } from "react";
import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { TrustedCounselSection } from "@/components/TrustedCounselSection";
import { GlobalCredibilitySection } from "@/components/GlobalCredibilitySection";
import { CredibilityStrip } from "@/components/CredibilityStrip";
import { AboutPreview } from "@/components/AboutPreview";
import { FounderSection } from "@/components/FounderSection";
import { CredentialsSection } from "@/components/CredentialsSection";
import { PracticeAreasGrid } from "@/components/PracticeAreasGrid";
import { DiasporaAdvisorySection } from "@/components/DiasporaAdvisorySection";
import { InvestmentProcessSection } from "@/components/InvestmentProcessSection";
import { FraudProtectionSection } from "@/components/FraudProtectionSection";
import { RecentTransactions } from "@/components/RecentTransactions";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { PackagesPreview } from "@/components/PackagesPreview";
import { SEOSection } from "@/components/SEOSection";
import { FAQSection } from "@/components/FAQSection";
import { DiasporaGuideSection } from "@/components/DiasporaGuideSection";
import { TrustedInvestorsSection } from "@/components/TrustedInvestorsSection";
import { OffMarketSection } from "@/components/OffMarketSection";
import { GlobalDiasporaSection } from "@/components/GlobalDiasporaSection";
import { LegalInsightsSection } from "@/components/LegalInsightsSection";
import { PrivateOpportunitiesSection } from "@/components/PrivateOpportunitiesSection";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <main className="min-h-screen bg-[#FAFAF9]" data-testid="home-page">
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <TrustedCounselSection />
      <GlobalCredibilitySection />
      <CredibilityStrip />
      <AboutPreview />
      <FounderSection />
      <CredentialsSection />
      <PracticeAreasGrid />
      <WhyChooseUs />
      <FraudProtectionSection />
      <InvestmentProcessSection />
      <DiasporaAdvisorySection />
      <RecentTransactions />
      <PackagesPreview />
      <SEOSection />
      <FAQSection />
      <DiasporaGuideSection />
      <TrustedInvestorsSection />
      <OffMarketSection />
      <GlobalDiasporaSection />
      <LegalInsightsSection />
      <PrivateOpportunitiesSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}
